var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-body", attrs: { id: "content-body" } },
    [
      _c(
        "div",
        { staticClass: "wysiwyg-content-region", class: _vm.wrapperClass },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.wysiwgBody) } })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }